export default {
	data() {
		return {
			hasError: false,
		};
	},
	methods: {
		async beforeHandleNext() {
			return new Promise(async (resolve, reject) => {
				this.$refs.form.validate().then(async success => {
					this.hasError = !success;

					if (success) {
						const result = await this.$refs.dataComponent.beforeNext();

						if (result.success) {
							resolve(result.routeTo);
						}
					} else {
						this.scrollIntoViewWithOffset('.error-field:first-of-type');
						return;
					}
				});
			});
		},
		async beforeHandlePrev() {
			return new Promise(async (resolve, reject) => {
				const result = await this.$refs.dataComponent.beforePrev();

				if (result.success) {
					resolve(result.routeTo);
				}
			});
		},
	},
};
